import React from 'react';
import Icona from '../Icona/Icona';
import { PopCheck, PopPanel, PopX2 } from '../Dialog/PopParts';
import FlatIcon from '../Icona/FlatIcon';

/*
    Blocchi visivi usati nelle schede della guida.
*/

const PersonIcon = ({ size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="8.5" r="4" />
        <path d="M4.5 21a7.5 7.5 0 0 1 15 0" />
    </svg>
);

//passaggi numerati
export const Steps = ({ color, items }) => (
    <ol className="guide-steps">
        {items.map((txt, i) => (
            <li key={i} className="guide-step">
                <span className={"guide-step-n pop-g-" + color + " pop-gloss-sm"}>{i + 1}</span>
                <span className="pop-txt">{txt}</span>
            </li>
        ))}
    </ol>
);

//riquadro "Lo sapevi?" (con icona e titolo diversi diventa un avviso)
export const Tip = ({ children, icon = "bulb", title = "Lo sapevi?" }) => (
    <PopPanel className="guide-tip">
        <Icona kind={icon} size={52} />
        <div className="guide-tip-body">
            <span className="guide-tip-title">{title}</span>
            <span className="pop-txt">{children}</span>
        </div>
    </PopPanel>
);

//i tre giocatori di una squadra
export const Roles = () => (
    <div className="guide-roles">
        <div className="guide-role">
            <span className="guide-avatar pop-g-blue pop-gloss"><PersonIcon size={40} /></span>
            <span className="guide-role-name">Suggeritore</span>
            <span className="guide-role-desc">Vede la parola sul display</span>
        </div>
        <div className="guide-role guide-role-main">
            <span className="guide-avatar pop-g-fire pop-gloss"><PersonIcon size={50} /></span>
            <span className="guide-role-name">Indovino</span>
            <span className="guide-role-desc">Non vede la parola e tiene il pulsante</span>
        </div>
        <div className="guide-role">
            <span className="guide-avatar pop-g-cyan pop-gloss"><PersonIcon size={40} /></span>
            <span className="guide-role-name">Suggeritore</span>
            <span className="guide-role-desc">Vede la parola sul display</span>
        </div>
    </div>
);

//esempio di domanda costruita dai suggeritori: un chip per turno, i due suggeritori si alternano
export const Chain = ({
    hidden = "MELA",
    words = ["QUALE", "FRUTTO", "AVVELENATO", "MANGIA", "BIANCANEVE?"],
    children = <>I suggeritori compongono una domanda, <b>una parola a testa</b>, finché l'indovino non capisce.</>
}) => (
    <PopPanel className="guide-chain">
        <div className="guide-chain-head">
            <span className="pop-cap">Esempio</span>
            <span className="pop-meta">Parola sul display: <b>{hidden}</b></span>
        </div>
        <div className="guide-chain-words">
            {words.map((w, i) => (
                <span key={i} className={"guide-chip pop-gloss-sm " + (i % 2 === 0 ? "pop-g-blue" : "pop-g-cyan")}>{w}</span>
            ))}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFB36B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M4 12h15M13 6l6 6-6 6" />
            </svg>
            <span className="guide-chip guide-chip-big pop-g-fire pop-gloss-sm">{hidden}!</span>
        </div>
        <span className="pop-txt">{children}</span>
    </PopPanel>
);

//numeri grandi (60 secondi, 3 passo, 2 raddoppi)
export const BigTiles = ({ items }) => (
    <div className="guide-bigtiles" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((it) => (
            <div key={it.label} className="guide-bigtile-col">
                <div className={"guide-bigtile pop-g-" + it.color + " pop-gloss"}>{it.value}</div>
                <span className="guide-bigtile-lbl">{it.label}</span>
            </div>
        ))}
    </div>
);

//schede con titolo e descrizione affiancate a un'icona
export const Cards = ({ items }) => (
    <div className="guide-cards">
        {items.map((it) => (
            <PopPanel key={it.title} className="guide-card">
                <Icona kind={it.icon} size={54} />
                <div className="guide-card-body">
                    <span className="guide-card-title">{it.title}</span>
                    <span className="pop-txt">{it.txt}</span>
                </div>
            </PopPanel>
        ))}
    </div>
);

//schermate del pulsante durante il turno
const MiniPhone = ({ children, layout = "" }) => (
    <div className="guide-phone" aria-hidden="true">
        <div className={"guide-screen " + layout}>{children}</div>
    </div>
);

//il pulsante RADDOPPIO in miniatura, con la stessa casella di quello vero (spuntata = attivo)
const DoubleMini = ({ color, on = false, wide = false }) => (
    <span className={"guide-mini" + (wide ? " guide-mini-wide" : "") + " pop-g-" + color}>
        <PopCheck state={on} tone="#0BAC3D" />
        RADDOPPIO
    </span>
);

//lit = acceso (il tempo scorre): come nel pulsante vero, il disco è più chiaro di quello da fermo
const RedButton = ({ lit }) => (
    <div className={"guide-redbtn" + (lit ? " guide-redbtn-lit" : "")}>
        <span className="guide-hl guide-hl-1"></span>
        <span className="guide-hl guide-hl-2"></span>
    </div>
);

export const PhoneStates = () => {
    const states = [
        {
            title: "PREMI PER GENERARE",
            txt: <>L'indovino preme il pulsante: sul display compare la nuova parola per i suggeritori.</>,
            screen: (
                <MiniPhone>
                    <span className="guide-scr-title">PREMI PER<br />GENERARE</span>
                    <RedButton />
                    <DoubleMini color="grey" />
                </MiniPhone>
            ),
        },
        {
            title: "CONCENTRATI...",
            txt: <>I suggeritori parlano. Appena ha capito, l'indovino preme di nuovo: <b>il tempo si ferma</b>.</>,
            screen: (
                <MiniPhone layout="guide-screen-mid">
                    <span className="guide-scr-title">CONCENTRATI...</span>
                    <RedButton lit />
                </MiniPhone>
            ),
        },
        {
            title: "PARLA ORA!",
            txt: <>L'indovino dice la risposta e tocca <b className="guide-c-green">CORRETTA</b> o <b className="guide-c-red">ERRATA</b>, oppure <b className="guide-c-orange">PASSO</b> per saltare la parola.</>,
            screen: (
                <MiniPhone layout="guide-screen-top">
                    <span className="guide-scr-title">PARLA ORA!</span>
                    <span className="guide-mini guide-mini-tall pop-g-green">CORRETTA</span>
                    <span className="guide-mini guide-mini-tall pop-g-red">ERRATA</span>
                    <span className="guide-mini guide-mini-tall pop-g-orange">PASSO</span>
                </MiniPhone>
            ),
        },
        {
            title: "ATTESA RISULTATI...",
            txt: <>Finito il tempo, i punti della squadra compaiono sul display.</>,
            screen: (
                <MiniPhone layout="guide-screen-center">
                    <span className="guide-scr-title">ATTESA<br />RISULTATI...</span>
                    <span className="guide-dots"><i></i><i></i><i></i></span>
                </MiniPhone>
            ),
        },
    ];

    return (
        <div className="guide-states">
            {states.map((s, i) => (
                <PopPanel key={s.title} className="guide-state">
                    {s.screen}
                    <div className="guide-state-body">
                        <div className="guide-state-head">
                            <span className="guide-step-n pop-g-red pop-gloss-sm">{i + 1}</span>
                            <span className="guide-state-title">{s.title}</span>
                        </div>
                        <span className="pop-txt">{s.txt}</span>
                    </div>
                </PopPanel>
            ))}
        </div>
    );
}

//le tre regole per il formato delle parole
const Mark = ({ ok }) => (
    <span className={"guide-mark pop-gloss-sm " + (ok ? "pop-g-green" : "pop-g-red")} aria-hidden="true">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
            {ok ? <path d="M5 12.5l4.5 4.5L19 7.5" /> : <path d="M6 6l12 12M18 6L6 18" />}
        </svg>
    </span>
);

const YesNo = ({ yes, no }) => (
    <div className="guide-yesno">
        <div className="guide-yesno-col">
            <span className="guide-yesno-head"><Mark ok /><span className="guide-yes">Sì</span></span>
            {yes}
        </div>
        <div className="guide-yesno-col">
            <span className="guide-yesno-head"><Mark /><span className="guide-no">No</span></span>
            {no}
        </div>
    </div>
);

export const WordRules = () => (
    <>
        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Una sola parola</span>
            <span className="pop-txt">Niente articoli né frasi: i suggeritori devono poterla far indovinare con una frase.</span>
            <YesNo
                yes={<>
                    <span className="guide-chip pop-g-blue pop-gloss-sm">MELA</span>
                    <span className="guide-chip pop-g-blue pop-gloss-sm">OMBRELLO</span>
                </>}
                no={<>
                    <span className="guide-chip guide-chip-no">LA MELA</span>
                    <span className="guide-chip guide-chip-no">UN OMBRELLO NERO</span>
                </>}
            />
        </PopPanel>
        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Raddoppio: due parole <PopX2 /></span>
            <span className="pop-txt">Le parole per il raddoppio devono contenere due parole. Quando scrivi uno spazio il gioco le segna da solo come raddoppio.</span>
            <YesNo
                yes={<span className="guide-chip pop-g-blue pop-gloss-sm">CAPPELLO ROSSO <PopX2 /></span>}
                no={<span className="guide-chip guide-chip-no"><s>CAPPELLO</s> <PopX2 off /></span>}
            />
        </PopPanel>
        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Massimo 17 caratteri</span>
            <span className="pop-txt">Spazi compresi. Per il nome di un gruppo il limite è 13.</span>
            <div className="guide-fields">
                <div className="guide-field-row">
                    <Mark ok />
                    <div className="guide-field pop-g-fire pop-gloss-sm"><span>BICICLETTA</span><span className="pop-count">10/17</span></div>
                </div>
                <div className="guide-field-row">
                    <Mark />
                    <div className="guide-field pop-g-red pop-gloss-sm"><span>PRECIPITEVOLISSIMO</span><span className="pop-count pop-count-over">18/17</span></div>
                </div>
            </div>
        </PopPanel>
    </>
);

/*
    Esempi della domanda: righe con ✓ / ✗ e chip.
    Word = parola, No = parola barrata, Say = frase intera (no = frase sbagliata)
*/
const Example = ({ ok = false, children }) => (
    <div className="guide-ex">
        <Mark ok={ok} />
        <div className="guide-ex-body">{children}</div>
    </div>
);

const Word = ({ children }) => <span className="guide-chip pop-g-blue pop-gloss-sm">{children}</span>;
const No = ({ children }) => <span className="guide-chip guide-chip-no">{children}</span>;
const Say = ({ no = false, children }) => (
    <span className={"guide-chip guide-chip-quote " + (no ? "guide-chip-no" : "pop-g-cyan pop-gloss-sm")}>{children}</span>
);

const Hidden = ({ word, double = false }) => (
    <div className="guide-hidden">
        <span className="pop-cap">Parola nascosta</span>
        <Word>{word}{double && <PopX2 />}</Word>
    </div>
);

//scheda "Come si formula la domanda": grammatica e risposta
export const QuestionRules = () => (
    <>
        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Grammatica corretta</span>
            <span className="pop-txt">La domanda deve essere corretta per grammatica e sintassi.</span>
            <Example><Say no>Quali animali abbaia di notte?</Say></Example>
            <Example ok><Say>Quale animale abbaia di notte?</Say></Example>
        </PopPanel>
        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Risposta identica</span>
            <span className="pop-txt">L'indovino deve dire esattamente la parola nascosta: una risposta compatibile ma diversa non vale.</span>
            <Hidden word="CANE" />
            <span className="pop-cap">L'indovino risponde</span>
            <Example ok><Word>CANE</Word></Example>
            <Example><No>CANI</No><No>CAGNOLINO</No></Example>
        </PopPanel>
    </>
);

//scheda "Parole vietate"
const Banned = ({ title, txt, hidden, double, no, yes }) => (
    <PopPanel className="guide-rule">
        <span className="guide-rule-title">{title}</span>
        <span className="pop-txt">{txt}</span>
        <Hidden word={hidden} double={double} />
        <Example>{no.map((w) => <No key={w}>{w}</No>)}</Example>
        <Example ok><Say>{yes}</Say></Example>
    </PopPanel>
);

export const BannedWords = () => (
    <>
        <Banned
            title="Stessa famiglia di parole"
            txt="Né la parola nascosta né le parole derivate o con la stessa radice."
            hidden="FIORE"
            no={["FIORISTA", "FIORITO"]}
            yes="Che cosa ha i petali e profuma?"
        />
        <Banned
            title="Altre lingue"
            txt="Nemmeno le traduzioni sono ammesse."
            hidden="SOLE"
            no={["SUN"]}
            yes="Qual è la stella che ci illumina di giorno?"
        />
        <Banned
            title={<>Gruppi di parole <PopX2 /></>}
            txt="Il divieto vale per ciascuna parola che compone il gruppo."
            hidden="ALBERO DI NATALE"
            double
            no={["ALBERO", "NATALIZIO", "ALBERELLO"]}
            yes="Cosa si addobba a dicembre con luci e palline?"
        />
        <Banned
            title="Marchi commerciali"
            txt="Niente nomi di marchi."
            hidden="TELEFONO"
            no={["IPHONE"]}
            yes="Quale oggetto usi per chiamare un amico?"
        />
    </>
);

//scheda "Formulazioni errate": pause lunghe e i tre casi con ammonizione
export const WrongQuestions = () => (
    <>
        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Pause troppo lunghe</span>
            <span className="pop-txt">Tra una parola e l'altra non possono passare più di 5 secondi fatti passare apposta. Qui non c'è ammonizione: la domanda è annullata subito.</span>
            <div className="guide-chain-words">
                <span className="guide-chip pop-g-blue pop-gloss-sm">QUALE</span>
                <span className="guide-chip pop-g-red pop-gloss-sm"><i>(6 SECONDI)</i></span>
                <span className="guide-chip pop-g-cyan pop-gloss-sm">ANIMALE</span>
            </div>
        </PopPanel>

        <Tip icon="warn" title="Ammonizione">
            Telegramma, scaricabarile e rima: la prima volta è solo un'ammonizione a voce. Se si ripete, l'indovino tocca ERRATA.
        </Tip>

        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Telegramma</span>
            <span className="pop-txt">Mancano articoli, preposizioni e pronomi: la frase sembra un telegramma.</span>
            <Hidden word="GELATO" />
            <Example><Say no>Dolce freddo cono estate</Say></Example>
            <Example ok><Say>Qual è il dolce freddo che si mangia in estate?</Say></Example>
        </PopPanel>

        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Scaricabarile</span>
            <span className="pop-txt">Un suggeritore inserisce parole a caso per lasciare la domanda al compagno.</span>
            <Hidden word="PIZZA" />
            <div className="guide-chain-words">
                <span className="guide-chip pop-g-blue pop-gloss-sm">QUALE</span>
                <span className="guide-chip pop-g-cyan pop-gloss-sm">PIATTO</span>
                <No>EHM</No>
                <span className="guide-chip pop-g-cyan pop-gloss-sm">ITALIANO</span>
                <No>BOH</No>
            </div>
            <span className="pop-meta">Le parole grigie non servono alla domanda.</span>
        </PopPanel>

        <PopPanel className="guide-rule">
            <span className="guide-rule-title">Rima</span>
            <span className="pop-txt">Non si può suggerire la parola facendo una rima.</span>
            <Hidden word="TORO" />
            <Example><Say no>Quale animale fa rima con coro?</Say></Example>
        </PopPanel>
    </>
);

//colori del pulsante RADDOPPIO
export const DoubleStates = ({ children }) => (
    <PopPanel className="guide-legend">
        <span className="guide-rule-title">Pulsante RADDOPPIO</span>
        {children && <span className="pop-txt">{children}</span>}
        <div className="guide-legend-row"><DoubleMini color="grey" wide /><span className="pop-txt">Non disponibile</span></div>
        <div className="guide-legend-row"><DoubleMini color="orange" wide /><span className="pop-txt">Puoi attivarlo</span></div>
        <div className="guide-legend-row"><DoubleMini color="green" on wide /><span className="pop-txt">Attivo: la prossima parola sarà doppia</span></div>
    </PopPanel>
);

//righe "cosa succede → punti"
export const ScoreList = ({ rows }) => (
    <div className="guide-score">
        {rows.map((r) => (
            <div key={r.what} className="guide-score-row">
                <span className={"guide-mini guide-mini-wide pop-g-" + r.color}>{r.btn}</span>
                <span className="pop-txt guide-score-what">{r.what}</span>
                <span className="guide-score-pts">{r.pts}</span>
            </div>
        ))}
    </div>
);

//messaggio del gioco → cosa fare
export const MsgList = ({ items }) => (
    <div className="guide-msgs">
        {items.map((it) => (
            <PopPanel key={it.msg} className="guide-msg">
                <div className="guide-msg-head">
                    <Icona kind="warn" size={34} />
                    <span className="guide-msg-txt">«{it.msg}»</span>
                </div>
                <span className="pop-txt">{it.fix}</span>
            </PopPanel>
        ))}
    </div>
);

//i due pulsanti in basso nelle schermate del gioco (stesse icone del gioco)
export const BottomButtons = ({ highlight }) => (
    <div className="guide-bottom" aria-hidden="true">
        <div className={"guide-bottom-btn pop-g-orange pop-gloss" + (highlight === "settings" ? " guide-bottom-on" : "")}>
            <FlatIcon name="gear" size={44} weight={2.4} />
        </div>
        <div className={"guide-bottom-btn pop-g-blue pop-gloss" + (highlight === "fullscreen" ? " guide-bottom-on" : "")}>
            <FlatIcon name="fullscreen" size={44} weight={2.4} />
        </div>
    </div>
);
